/**
 * Ory APIs
 *
 * Contact: support@ory.sh
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ContinueWithSettingsUiFlow } from './continueWithSettingsUiFlow';


/**
 * Indicates, that the UI flow could be continued by showing a settings ui
 */
export interface ContinueWithSettingsUi { 
    /**
     * Action will always be `show_settings_ui` show_settings_ui ContinueWithActionShowSettingsUIString
     */
    action: ContinueWithSettingsUi.ActionEnum;
    flow: ContinueWithSettingsUiFlow;
}
export namespace ContinueWithSettingsUi {
    export type ActionEnum = 'show_settings_ui';
    export const ActionEnum = {
        ShowSettingsUi: 'show_settings_ui' as ActionEnum
    };
}


